import session from '../util/session'
import isEmpty from 'lodash-es/isEmpty'
import TomSelect from 'tom-select/dist/js/tom-select.base.js'

up.compiler('[data-set-values-from-session]', (element: HTMLElement) => {
  const fields: Record<string, string | null | undefined> = {
    education_level: session.educationLevel,
    university_id: session.universityIdAndKey,
    study_course_id: session.studyCourseIdAndKey,
    study_start: session.studyStart,
    gender: session.gender,
    school_region: session.schoolRegion,
    school_name: session.schoolName,
    parents_school_name: session.schoolName,
    pupils_school_name: session.schoolName,
    teachers_school_name: session.schoolName,
    parents_school_grade: session.schoolGrade,
    pupils_school_grade: session.schoolGrade,
    school_zipcode: session.schoolZipcode,
    parents_school_zipcode: session.schoolZipcode,
    pupils_school_zipcode: session.schoolZipcode,
    teachers_school_zipcode: session.schoolZipcode,
  }

  function setFieldsFromSession(container: Element): void {
    for (const [key, value] of Object.entries(fields)) {
      const nameSelector = `[name*="[${key}]"]`
      const invalidForm = !!container.querySelector('.is-invalid')
      if (!isEmpty(value)) {
        const regularInput = container.querySelector<HTMLInputElement>(
          `${nameSelector}:not([type="radio"]):not([data-place-select]):not([type="hidden"])`,
        )
        if (regularInput && !regularInput.value && !regularInput.classList.contains('is-invalid')) {
          regularInput.value = value!

          const tomselect = (
            regularInput as HTMLInputElement & { tomselect?: InstanceType<typeof TomSelect> }
          ).tomselect
          if (tomselect !== undefined) {
            tomselect.sync()
          }
          up.emit(regularInput, 'change')
        }

        const radioInputToCheck = container.querySelector<HTMLInputElement>(
          `${nameSelector}[type="radio"][value="${value}"]`,
        )
        if (radioInputToCheck && !invalidForm) {
          radioInputToCheck.checked = true
          up.emit(radioInputToCheck, 'change')
        }

        const placeSelectsToFill = container.querySelectorAll<HTMLElement>(
          `${nameSelector}[data-place-select]`,
        )
        placeSelectsToFill.forEach((placeSelectToFill) => {
          // To get an initial value for this ajax select field, we trigger an up validate and send the school_zipcode as param to the server.
          // With that the corresponding place can be determined and the select can be filled with that place as only option.
          const upValidateTarget = placeSelectToFill.getAttribute('up-validate')!
          const place = placeSelectToFill.closest<HTMLElement>('.place')!
          const educationAttribute = place.getAttribute('for-education-level')

          if (!placeSelectToFill.classList.contains('is-invalid')) {
            up.validate(container as HTMLElement, {
              target: `.place[for-education-level=${educationAttribute}], ${upValidateTarget}`,
              params: { 'user_study_info_form[school_zipcode]': value! },
            }).then(() => {
              setFieldsFromSession(document.querySelector(upValidateTarget)!)
            })
          }
        })
      }
    }
  }

  setFieldsFromSession(element)
})
